module.exports = __webpack_public_path__ + "media/images/subject_img/BIOPHYSICS-376782da48479114df2cafbb057fb68c.jpg";